import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const referralListDetailsApi = createApi({
  reducerPath: "referralListDetails",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["ReferralListDetail"],
  endpoints: (builder) => ({
    getReferralListDetailsById: builder.query({
      query: (id) => ({
        url: `${Apis.referralListDetails}/${id}`,
      }),
      providesTags: ["ReferralListDetail"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetReferralListDetailsByIdQuery } = referralListDetailsApi;
